// src/config/routes/public.routes.ts
import { Columns3Cog, HandHelping, NotebookText, UserRound, NotebookPen, Wallet, BadgeAlert, TreeDeciduous, LayoutDashboard, User } from 'lucide-react';
import { lazy } from 'react';
import { RouteConfig } from 'src/types/route-config.types';

export const protectedRoutes: RouteConfig[] = [
    // --- Onboarding Section ---
    {
        name: "Dashboard",
        path: "/dashboard",
        component: lazy(() => import('src/pages/dashboard/DashboardPage')),
        showInSideNav: true,
        sideNavGroupName: "",
        access: ["generator"],
        breadcrumbPath: ["Dashboard"],
        icon: <LayoutDashboard className='h-5 w-5' />,
        isDefaultFor: ["generator"],
        order: 1,
        meta: {
            title: "Generator Dashboard",
            description: "Transparency & traceability of Generation activities."
        }
    },

    {
        name: "Energy Monitoring",
        path: "/energy-monitoring",
        component: lazy(() => import('src/pages/energy-monitoring/EnergyMonitoringDashboardPage')),
        showInSideNav: true,
        sideNavGroupName: "",
        access: ["generator"],
        breadcrumbPath: ["dashboard"],
        icon: <User className='h-2 w-2' />,
        order: 3,
        meta: {
            title: "Energy Monitoring Dashboard",
            description: "Track your green energy usage, token balance, and GEC certificate in one place"
        }
    },

           {
        name: "Generator Energy Audit Reports",
        path: "/energy-audit/generator-report",
        component: lazy(() => import('src/pages/audit-report/generator/audit-report/GeneratorAuditReport')),
        showInSideNav: false,
        sideNavGroupName: "",
        access: ["generator"],
        breadcrumbPath: ["energy-setting", "Energy Setting Form"],
        // icon: <FunctionSquare className='h-4 w-4' />,
        order: 8.2,
        meta: {
            title: "Generator Energy Audit Report",
            description: "Generation energy audit report with detailed analytics"
        }
    },

    {
        name: "Generator Energy Audit Details",
        path: "/energy-audit/generator-details",
        component: lazy(() => import('src/pages/audit-report/generator/audit-details/GeneratorAuditDetails')),
        showInSideNav: false,
        sideNavGroupName: "",
        access: ["generator", "administrator"],
        breadcrumbPath: ["dashboard"],
        icon: <User className='h-2 w-2' />,
        order: 3,
        meta: {
            title: "Generator Energy Audit",
            description: "Monitor energy Generation with detailed analytics."
        }
    },

    {
        name: "Plants",
        path: "/plants",
        component: lazy(() => import('src/pages/onboarding/generators/generators-report/GeneratorsReportPage')),
        showInSideNav: true,
        sideNavGroupName: "",
        access: ["generator"],
        breadcrumbPath: ["Dashboard"],
        icon: <TreeDeciduous className='h-5 w-5' />,
        isDefaultFor: ["generator"],
        order: 1,
        meta: {
            title: "Add New Plant",
            description: "Transparency & traceability of system activities."
        }
    },




    {
        name: "Generator Profile",
        path: "/onboarding/generator/profile-details/:consumer_id",
        component: lazy(() => import('src/pages/onboarding/generators/generator-profile/GeneratorProfilePage')),
        showInSideNav: false,
        sideNavGroupName: "Onboarding",
        access: ["generator"],
        breadcrumbPath: ["Onboarding", "generator"],
        icon: <BadgeAlert className='h-5 w-5' />,
        isDefaultFor: [""],
        order: 1,
        meta: {
            title: "Performance Alerts",
            description: "Alerts for missing data, underperformance, or device sync failures"
        }
    },




    {
        name: "Transaction History",
        path: "/token-wallet",
        component: lazy(() => import('src/pages/token-wallet/Dashboard')),
        showInSideNav: true,
        sideNavGroupName: "",
        access: ["generator"],
        breadcrumbPath: ["Dashboard"],
        icon: <Wallet className='h-5 w-5' />,
        isDefaultFor: [""],
        order: 1,
        meta: {
            title: "Token Wallet",
            description: "To show token details."
        }
    },



    // {
    //     name: "GEC Summary",
    //     path: "/gec-summary",
    //     component: lazy(() => import('src/pages/gec-summary/Dashboard/dashboard')),
    //     showInSideNav: true,
    //     sideNavGroupName: "",
    //     access: ["generator"],
    //     breadcrumbPath: ["Dashboard"],
    //     icon: <NotebookPen className='h-5 w-5' />,
    //     isDefaultFor: [""],
    //     order: 1,
    //     meta: {
    //         title: "GEC Summary",
    //         description: "Summary of Green Energy Certificates (GECs)."
    //     }
    // },


    //   {
    //     name: "GEC Association",
    //     path: "/gec-association",
    //     component: lazy(() => import('src/pages/gec-association/Dashbaord')),
    //     showInSideNav: true,
    //     sideNavGroupName: "",
    //     access: ["generator"],
    //     breadcrumbPath: ["Dashboard"],
    //     icon: <UserRound className='h-5 w-5' />,
    //     isDefaultFor: [""],
    //     order: 1,
    //     meta: {
    //         title: "GEC Association",
    //         description: "Association of tokens to Green Energy Certificates (GECs) issued downstream to consumers."
    //     }
    // },


    // {
    //     name: "Sustainability & Impact Reports",
    //     path: "/sustainability-impact-reports",
    //     component: lazy(() => import('src/pages/sustainability-impact-reports/dashboard/DashbaordAnalysis')),
    //     showInSideNav: true,
    //     sideNavGroupName: "",
    //     access: ["generator"],
    //     breadcrumbPath: ["Dashboard"],
    //     icon: <NotebookText className='h-5 w-5' />,
    //     isDefaultFor: [""],
    //     order: 1,
    //     meta: {
    //         title: "Sustainability Impact Reports",
    //         description: "Reports showing carbon offset based on generation volume across various periods."
    //     }
    // },

    {
        name: "Performance Alerts",
        path: "/performance-alerts",
        component: lazy(() => import('src/pages/performance-alert/dashboard/performance-alert')),
        showInSideNav: true,
        sideNavGroupName: "",
        access: ["generator"],
        breadcrumbPath: ["Dashboard"],
        icon: <BadgeAlert className='h-5 w-5' />,
        isDefaultFor: [""],
        order: 1,
        meta: {
            title: "Performance Alerts",
            description: "Alerts for missing data, underperformance, or device sync failures"
        }
    },


    {
        name: "Help & Support",
        path: "/help-support",
        component: lazy(() => import('src/pages/self-service/query-requests/QueryRequestsPage')),
        showInSideNav: true,
        sideNavGroupName: "",
        access: ["generator"],
        breadcrumbPath: ["Dashboard"],
        icon: <HandHelping className='h-5 w-5' />,
        isDefaultFor: [""],
        order: 1,
        meta: {
            title: "Help & Support",
            description: "Submit and track your queries related to GEC services."
        }
    },



    // {
    //     name: "Configurations",
    //     path: "/self-service/configurations",
    //     component: lazy(() => import('src/pages/self-service/configurations/ConfigurationsPage')),
    //     showInSideNav: true,
    //     sideNavGroupName: "Self-Service",
    //     access: ["generator"],
    //     breadcrumbPath: ["Self-Service", "Configurations"],
    //     icon: <Columns3Cog className='h-5 w-5' />,
    //     isDefaultFor: ["generator"],
    //     order: 2,
    //     meta: {
    //         title: "Configuration",
    //         description: "To register an eligible generator for energy usage."
    //     }
    // },
    // {
    //     name: "queries",
    //     path: "/self-service/queries",
    //     component: lazy(() => import('src/pages/self-service/query-requests/QueryRequestsPage')),
    //     showInSideNav: true,
    //     sideNavGroupName: "Self-Service",
    //     access: ["generator"],
    //     breadcrumbPath: ["Self-Service", "Queries"],
    //     icon: <User className='h-2 w-2' />,
    //     isDefaultFor: ["generator"],
    //     order: 3,
    //     meta: {
    //         title: "Query Submission",
    //         description: "To register an eligible generator for energy usage."
    //     }
    // },
    // {
    //     name: "Billing",
    //     path: "/billing",
    //     component: lazy(() => import('src/pages/billing/Index')),
    //     showInSideNav: true,
    //     sideNavGroupName: "Billing",
    //     access: ["*"],
    //     breadcrumbPath: ["Onboarding", "billing"],
    //     icon: <User className='h-2 w-2' />,
    //     isDefaultFor: ["generator"],
    //     order: 4,
    //     meta: {
    //         title: "Billing Summary",
    //         description: "Display a quick Summary of the most recent bill"
    //     }
    // },

];